import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/* Global banner shown whenever an admin is viewing the portal as another
 * role. Sticky at the top, always visible, one-click return to admin. */
const ROLE_LABELS = {
    admin: "Admin",
    manager: "Manager",
    supervisor: "Supervisor",
    safety: "Safety Officer",
    client_liaison: "Client Liaison",
    finance: "Finance",
    fel_operator: "FEL Operator",
    fleet_manager: "Fleet Manager",
    plant_manager: "Plant Manager (view-only)",
    shift_millwright: "Shift Millwright",
    electrician: "Electrician",
    weighbridge_supervisor: "Weighbridge Supervisor",
    tippler_operator: "Tippler Operator",
    hr: "HR / People",
    tfr_yard: "TFR Yard Controller",
    rail_coordinator: "Grindrod Rail Coordinator",
    mine_rail_planner: "Mine Rail Planner",
};

export default function ImpersonationBanner() {
    const auth = useAuth() || {};
    const { isImpersonating, viewAsRole, stopViewAs } = auth;
    const nav = useNavigate();
    if (!isImpersonating) return null;

    const label = ROLE_LABELS[viewAsRole] || viewAsRole;
    const back = () => {
        stopViewAs();
        // Return to the admin dashboard
        nav("/portal");
    };

    return (
        <div
            className="w-full flex items-center justify-between gap-3 px-3 md:px-6 py-2 text-white text-xs md:text-sm font-semibold sticky top-0 z-[60] shadow-md"
            style={{ background: "linear-gradient(90deg, #B45309 0%, #F59E0B 100%)" }}
            data-testid="impersonation-banner"
            role="status"
            aria-live="polite"
        >
            <div className="flex items-center gap-2 min-w-0">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="2.5"
                     strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                </svg>
                <span className="uppercase tracking-widest text-[10px] md:text-[11px] opacity-90">
                    Admin preview mode
                </span>
                <span className="hidden md:inline opacity-90">·</span>
                <span className="truncate">
                    Viewing the portal as <b className="uppercase">{label}</b>
                </span>
            </div>
            <button
                type="button"
                onClick={back}
                data-testid="impersonation-return-btn"
                className="whitespace-nowrap px-3 py-1.5 rounded-full bg-white text-[#B45309] hover:bg-slate-100 text-[11px] md:text-xs font-black uppercase tracking-wider shadow"
            >
                ← Return to admin
            </button>
        </div>
    );
}
